import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import {
  columnCategory,
  columnCode,
  columnDescription,
  columnNameLink,
  columnPermissions,
  columnTools,
  columnUsers,
} from '@/constants/fields';
import { states } from '@/constants/lifecycle';
import { presentationOptions } from '@/constants/states';
import { fitToPage, goToCategoryPage } from '@/hooks/paging';
import TableWrapper from '@/components/table/TableWrapper';
import NoRowsWithPagination from '@/components/table/NoRowsWithPagination';
import { noRowsToDisplay } from '@/components/table/NoRowsWrapper';
import ToggleCardsButton from '@/components/cards/ToggleCardsButton';
import RolesFilters from '../containers/RolesFilters';
import RolesTableHeader from './RolesTableHeader';
import RolesTableRows from '../containers/RolesTableRows';

const RolesTable = ({
  allowCreate,
  category,
  className,
  columns = [
    columnNameLink,
    columnCode,
    columnUsers,
    columnPermissions,
    columnDescription,
    columnCategory,
    columnTools,
  ],
  currentPage,
  defaultRole,
  fetchData,
  hideColumns,
  hideFlags,
  newRole,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  roles,
  selectable,
  togglePresentation,
  total,
}) => {
  const { items, pageNumber } = fitToPage(roles, currentPage, pageSize);
  const ref = React.useRef(null);

  return (
    <div className={clsx('ReactTable', className)} ref={ref}>
      <div className={noRowsToDisplay(items, [readStatus], readErrors) ? '' : 'inner'}>
        <TableWrapper sticky celled className="aridhia-roles-table" columns={columns}>
          <RolesTableHeader
            category={category}
            columns={columns}
            hideColumns={hideColumns}
            readStatus={readStatus}
            readErrors={readErrors}
            roles={items}
          >
            {togglePresentation && (readStatus !== states.PENDING) && (
            <ToggleCardsButton
              display={presentationOptions.TABLE}
              disabled={readStatus === states.PENDING}
              onClick={() => togglePresentation(category, presentationOptions.CARDS)}
            />
            )}
            <RolesFilters category={category} className="aridhia-table-filter" hideFlags={hideFlags} />
          </RolesTableHeader>
          <Table.Body>
            <RolesTableRows
              category={category}
              columns={columns}
              defaultRole={defaultRole}
              items={items}
              selectable={selectable}
            />
          </Table.Body>
        </TableWrapper>
      </div>
      <NoRowsWithPagination
        canCreate={allowCreate}
        currentPage={pageNumber}
        entity="role"
        goToPage={({ page }) => goToCategoryPage(fetchData, category, page, ref)}
        icon="drivers license"
        items={items}
        onClick={newRole}
        pageCount={pageCount}
        readErrors={readErrors}
        readStatus={readStatus}
        total={total}
      />
    </div>
  );
};

export default RolesTable;
